import { createWithInjectedPropsFunc } from '../utilities/createWithInjectedPropsFunc';
import { container } from './container';

export const withInjectedProps = createWithInjectedPropsFunc(container);
